import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import {
  ButtonWrapper,
} from '../../components';

const NotFound = () => {
  const { t } = useTranslation();
  return (
    <Container>
      <Helmet>
        <title>{t('pages.404.title')}</title>
      </Helmet>
      <div className="row">
        <div className="col-12 col-md-10 offset-md-1">
          <div className="NotFound">
            <h1>{t('pages.404.title')}</h1>
            <p>{t('pages.404.body')}</p>
            <div className="Buttonwrapper">
              <ButtonWrapper href={t('pages.404.primary_button.url')}>
                {t('pages.404.primary_button.link')}
              </ButtonWrapper>
              <ButtonWrapper type="secondary" href={t('pages.404.secondary_button.url')}>
                {t('pages.404.secondary_button.link')}
              </ButtonWrapper>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default NotFound;
